import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import i18next from 'i18next';
import Text from '../../../../components/common/Text';
import OrderStatusTitle from './OrderStatusTitle';
import { PreviewTextEditor } from '../../../../components/RestInput/RestTextEditor/index';

const AssignDesigner = ({ item }) => (
  <Card title={<OrderStatusTitle item={item} />} className="timelineItem">
    <Text type="body">
      {i18next.t(`orderHistories.status.description.${item.status}.${item.accept}`)}
    </Text>
    {item.report && (
      <Text type="h5" color="red">
        {i18next.t('orderHistories.feedback')}
        :
        <br />
        <PreviewTextEditor html={item.report} />
      </Text>
    )}
  </Card>
);

AssignDesigner.propTypes = {
  item: PropTypes.object,
};

export default AssignDesigner;
